export function SQLInjectionPdf() {
    const quizzes = [
      {
        title: "Practice for HTML (UnityDoc)",
        url: "https://www.w3schools.com/html/html_quiz.asp"
      }
      // You can add more quizzes to this array in the future if needed
    ];
  
    return (
      <>
        <h1 className="html_qns_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 8</strong> recommended Geeks for Geeks links that you can refer to with important topics.
        </h1>
  
        <h4 className="des_qns_html">
          1. Dive into the <strong>Main</strong> Page <br />
          2. Start with Quizzes <br />
          3. Test your knowledge and attempt for better clarification.
        </h4>
  
        {quizzes.map((quiz, index) => (
          <div key={index} className="container_html_qns_links">
            <p className="vid" style={{ marginTop: '50px' }}>
              {quiz.title}
              <button 
                className="quiz-button" 
                onClick={() => window.open(quiz.url, "_blank")}
                aria-label={`Go to ${quiz.title}`}
              >
                Click Me
              </button>
            </p>
          </div>
        ))}
      </>
    );
  }
  
  export default SQLInjectionPdf;
  